import { useState, useCallback, useEffect, forwardRef } from "react";
import debounce from "lodash.debounce";
import TextInput from "@inovua/reactdatagrid-community/packages/TextInput";

const renderClearIcon = ({ width, height }) => (
  <svg style={{ width, height }} viewBox="0 0 10 10">
    <path
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeWidth="1.33"
      d="M1 1l8 8m0-8L1 9"
    />
  </svg>
);

const GridIdField = forwardRef(
  (
    {
      filterValue,
      onChange,
      filterDelay,
      render,
      readOnly,
      disabled,
      style,
      rtl,
      theme,
      placeholder,
    },
    ref
  ) => {
    const [value, setValue] = useState(filterValue?.value ?? "");

    const debouncedOnChange = useCallback(
      debounce((val) => onChange(val), filterDelay >= 1 ? filterDelay : 1000, {
        leading: false,
        trailing: true,
      }),
      [filterDelay, onChange]
    );

    useEffect(() => {
      return () => {
        debouncedOnChange.cancel();
      };
    }, [debouncedOnChange]);

    const handleChange = (inputVal) => {
      const re = /^[0-9\b]+$/;
      if (inputVal === "" || re.test(inputVal)) {
        setValue(inputVal);
        debouncedOnChange(Object.assign({}, filterValue, { value: inputVal }));
      }
    };

    const inputEl = (
      <TextInput
        ref={ref}
        type="text"
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        theme={theme}
        rtl={rtl}
        placeholder={placeholder}
        onChange={handleChange}
        renderClearIcon={renderClearIcon}
        style={{ minWidth: 0, ...style }}
        className="InovuaReactDataGrid__column-header__filter InovuaReactDataGrid__column-header__filter--string"
      />
    );

    return render ? render(inputEl) : inputEl;
  }
);

GridIdField.displayName = "GridIdField";

export default GridIdField;
